import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Modal from "../../../components/MuiComponents/Modal";
import OtpForm from "./SignupModal/OtpForm";
import PasswordForm from "./SignupModal/PasswordForm";
import SuccessContent from "./SignupModal/SuccessContent";
import {useNavigate} from "react-router-dom";
import EnterEmailModal from "./ForgotPasswordModal/EnterEmailModal";
import {useDispatch, useSelector} from "react-redux";
import {clearFormError, setForgotPasswordModal, setTokenFromOtp} from "../../../redux/reducers/auth";

const SignupModal = ({open}) => {
    const forgotPasswordModal = useSelector(state => state.auth.forgotPasswordModal)
    const [modal, setModal] = useState(forgotPasswordModal ? "email" : "otp")
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const submit = (modal, data) => {
        if (modal === "email") {
            setModal("otp")
        }
        if (modal === "otp") {
            setModal("password")
        }
        if (modal === "password") {
            setModal("success")
        }
    }
    const handleClose = () => {
        if (forgotPasswordModal) {            
            dispatch(setForgotPasswordModal(false))
            dispatch(clearFormError("forgot_password"))
        } else {
            // clear token from received from otp confirm
            dispatch(setTokenFromOtp(null))
            navigate("/")
        }
        dispatch(clearFormError("otp_form"))
    }

    return (
        <div>
            <Modal {...((modal === "success" || (forgotPasswordModal && ["email", "otp"].includes(modal))) && {onClose: handleClose})}
                   maxWidth={"xs"} open={open}>
                {modal === "email" && <EnterEmailModal {...{submit}} close={handleClose} />}
                {modal === "otp" && <OtpForm {...{submit}} />}
                {modal === "password" && <PasswordForm {...{submit}} />}
                {modal === "success" && <SuccessContent close={handleClose}/>}
            </Modal>
        </div>
    );
};

SignupModal.propTypes = {
    data: PropTypes.object,
    open: PropTypes.bool,
};

export default SignupModal;
